import React from 'react';
import { UnsafeHTML, Paper, TypographyHeading, TypographyStyler, FlexGrid } from '@honeycomb/ui-core';
export function Headline({ header, details }) {
    return (React.createElement(FlexGrid, { container: true, justifyContent: "center" },
        React.createElement(FlexGrid, { s: 12, m: 10, l: 8 },
            React.createElement(Paper, { p: 6 },
                React.createElement(TypographyHeading, { component: "h2", size: "m", mb: 3, ta: "center" }, header),
                React.createElement(TypographyStyler, { ta: "center" },
                    React.createElement(UnsafeHTML, null, details))))));
}
